import React, { useState, useCallback, useMemo } from "react";
import classNames from "classnames";

export const Input = (props) => {
  const {
    className,
    label,
    id,
    placeholder,
    middle,
    disabled,
    input,
    lastLabel,
    meta,
    maxLength,
    animated,
    onBlur,
    readOnly,
    pattern,
    value,
    onChange,
    testId,
  } = props;

  const [focus, setFocus] = useState(false);
  const inputValue = useMemo(() => value ?? input.value, [input.value, value]);

  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      const patt = new RegExp(pattern);
      const isOneCharShorter = value.length === inputValue?.length - 1;
      const isAlmostEqual =
        isOneCharShorter && input.value.indexOf(value) === 0;
      if ((!value || patt.test(value) || isAlmostEqual) && input) {
        input.onChange(value);
      }
      if (onChange) {
        onChange(input.name, value);
      }
    },
    [input, onChange, pattern, inputValue]
  );

  return (
    <div
      id={id}
      className={classNames({
        "has-error": meta.error && meta.touched,
      })}
    >
      <label
        id={id + "-label"}
        data-testId={`${testId}-label`}
        htmlFor={id + "-input"}
        className={classNames(
          middle ? "label-Admin-Pickers-middle" : "label-Admin-Pickers",
          {
            labelError: meta.error && meta.touched,
            "label-login": animated,
            disabled: disabled,
            readonly: readOnly,
            "last-label": lastLabel,
            [inputValue || focus === true ? "animationTop" : "animationOrigin"]:
              animated,
          }
        )}
      >
        {label}
      </label>
      <input
        className={classNames(className, {
          disabled: disabled,
          readonly: readOnly,
          inputError: meta.error && meta.touched,
          [meta.error && meta.touched ? "inputReboteAnimation" : ""]: animated,
        })}
        data-testId={testId}
        type={input.type}
        name={input.name}
        disabled={disabled}
        readOnly={readOnly}
        id={id + "-input"}
        value={inputValue}
        placeholder={placeholder}
        onChange={handleChange}
        onFocus={() => {
          animated
            ? (function () {
                setFocus(true);
                input.onFocus();
              })()
            : input.onFocus();
        }}
        onBlur={() => {
          onBlur
            ? (() => {
                input.onBlur();
                onBlur();
              })()
            : animated
            ? (function () {
                setFocus(false);
                input.onBlur();
              })()
            : input.onBlur();
        }}
        maxLength={maxLength}
        autoComplete="off"
      />
      {meta.error && meta.touched && (
        <div className="input-errors-container" id={id + "-error"}>
          <p className="errors" data-testId={`${testId}-error`}>
            {meta.error}
          </p>
        </div>
      )}
    </div>
  );
};
